(function () {
  angular.module('MktzapApp.Factories')
    .factory('ReportsService', ReportsService);

  ReportsService.$inject = ['$resource'];

  function ReportsService ($resource) {
    return $resource(apiUrl + '/reports/common/:name', { name: '@name' }, {});
  }
})();
